import { Component, ChangeDetectorRef } from '@angular/core';
import { LoaderService } from './services/loader.service';
import { WindowReferenceService } from './window-reference.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  isLoading: boolean = false;

  constructor(private _loaderService: LoaderService, private _changeDetectionRef: ChangeDetectorRef, private _winRef: WindowReferenceService) {
    this._loaderService.loadingChange.subscribe(value => {
        this.isLoading = value;
    });

    // this._winRef.nativeWindow.Stripe(environment.stripe_publishable_key);
  }

  ngAfterContentChecked() {
    this._changeDetectionRef.detectChanges();
  }
}
